<edit-modal-layout [form]="htForm"
  (save)="send($event)"
  (onCancel)="cancel()">

  <h1>{{'Create a Help Desk Ticket' | translate }}</h1>
  <form novalidate
    class="flex-form"
    [formGroup]="htForm"
    (ngSubmit)="send($event)"
    (keydown.enter)="$event.preventDefault()">

    <mat-form-field>
      <mat-label>{{'How can we help?' | translate}}</mat-label>
      <mat-select formControlName="module" name="module" >
        @for (module of modules; track module) {
          <mat-option value={{module.id}}>
            {{ module.name }}
          </mat-option>
        }
      </mat-select>
      @if (htForm.get('module').errors?.required) {
        <mat-error>
          {{'This field is required.' | translate}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{'Issue' | translate}}</mat-label>
      <textarea formControlName="description" matInput cdkTextareaAutosize
        [cdkAutosizeMinRows]="5" (keydown.enter)="$event.stopPropagation()"
      [placeholder]="'Please describe your issue in detail' | translate" type="text"></textarea>
      @if (htForm.get('description').errors?.required) {
        <mat-error>
          {{'Issue is required.' | translate}}
        </mat-error>
      }
    </mat-form-field>
  </form>
</edit-modal-layout>
